import { createPortal } from "react-dom";
import {
	Button,
	ButtonSize,
	BorderRadius,
	Typography,
	BackgroundColors,
	BorderColors,
} from "@abel-technologies-as/components";
import { Loader } from "@mantine/core";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Overlay = styled.div`
	position: fixed;
	inset: 0;
	z-index: 9999;
	background-color: rgba(0, 0, 0, 0.55);
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 24px;
`;

interface GlobalExportLoaderProps {
	format?: "csv" | "xlsx";
	onCancel: () => void;
}

export const GlobalExportLoader = ({ format, onCancel }: GlobalExportLoaderProps) => {
	const title = format === "csv" ? "Export CSV file" : "Export XLSX file";
	const { t } = useTranslation("common");

	return createPortal(
		<Overlay>
			<Typography color="white" fontSize="20px" fontWeight={600} lineHeight="28px" fontFamily="Inter-SemiBold">
				{title}
			</Typography>
			<Loader size="lg" color="white" />
			<Button
				borderSize="1px"
				borderRadius={`${BorderRadius.MD}px`}
				size={ButtonSize.SMALL}
				borderColor={BorderColors.ErrorSolid}
				filled
				backgroundColor={BackgroundColors.ErrorSolid}
				boxShadow="0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
				onClick={onCancel}>
				<Typography
					margin="0 0 0 4px"
					color="white"
					fontSize="14px"
					fontWeight={600}
					lineHeight="20px"
					fontFamily="Inter-SemiBold">
					{t("cancel")}
				</Typography>
			</Button>
		</Overlay>,
		document.body
	);
};
